import React from "react";
import Icon, { IconName } from "../Icon";
import { MatchStatus } from "../types";

const MAP: Record<MatchStatus, { label: string; cls: string; icon: IconName }> =
  {
    matched: { label: "Matched", cls: "completed", icon: "check" },
    mismatched: { label: "Mismatched", cls: "failed", icon: "alert-circle" },
    pending: { label: "No payments", cls: "pending", icon: "clock" },
  };

const MatchPill: React.FC<{ value: MatchStatus }> = ({ value }) => {
  const meta = MAP[value];
  return (
    <span className={`status ${meta.cls}`}>
      <Icon name={meta.icon} size={11} strokeWidth={2.5} />
      {meta.label}
    </span>
  );
};

export default MatchPill;
